import { config } from '../config/config';
import axiosInstance from './axiosConfig';

export interface WizardProgress {
  currentStep: number;
  formData: string;
  lastUpdated: string;
  isCompleted: boolean;
}

export const wizardService = {
  async getProgress(): Promise<WizardProgress> {
    try {
      const response = await axiosInstance.get(`${config.getApiRoot()}/wizard-progress/current`);
      return response.data;
    } catch (error) {
      console.error('Error fetching wizard progress:', error);
      // Return default progress if API call fails
      return {
        currentStep: 1,
        formData: '{}',
        lastUpdated: new Date().toISOString(),
        isCompleted: false
      };
    }
  },

  async saveProgress(step: number, formData: any): Promise<void> {
    try {
      await axiosInstance.post(`${config.getApiRoot()}/wizard-progress/save-current?currentStep=${step}`, 
        JSON.stringify(formData),
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
    } catch (error) {
      console.error('Error saving wizard progress:', error);
      throw error;
    }
  },

  async validateStep(step: number, formData: any): Promise<boolean> {
    try {
      const response = await axiosInstance.post(`${config.getApiRoot()}/wizard-progress/validate-current?currentStep=${step}`, 
        JSON.stringify(formData),
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data.isValid;
    } catch (error) {
      console.error('Error validating step:', error);
      // For now, return true to allow progression if validation fails
      return true;
    }
  },

  async markAsCompleted(): Promise<void> {
    try {
      await axiosInstance.post(`${config.getApiRoot()}/wizard-progress/current/complete`);
    } catch (error) {
      console.error('Error marking wizard as completed:', error);
      throw error;
    }
  }
};